export var ListType;
(function (ListType) {
    ListType[ListType["REGULAR"] = 0] = "REGULAR";
    ListType[ListType["DECATHLON"] = 1] = "DECATHLON";
})(ListType || (ListType = {}));
